export default "__VITE_ASSET__Bu0A_vli__"